import React from "react";
import { makeStyles } from "@material-ui/core";
import EmailOutlinedIcon from "@mui/icons-material/EmailOutlined";
import PhoneIcon from "@mui/icons-material/Phone";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import { Link } from "react-router-dom";
import { routes } from "../../routing/routes";

const policyLinks = [
  { label: "Privacy Policy", path: routes.PRIVACY_POLICY },
  { label: "Terms & Conditions", path: routes.TERMS_AND_CONDITIONS },
  { label: "Refund Policy", path: routes.REFUND_POLICY },
  { label: "Return Policy", path: routes.RETURN_POLICY },
  { label: "Delivery Policy", path: routes.DELIVERY_POLICY },
];

const customStyles = makeStyles({
  root: {
    backgroundColor: "#000000", // Black background
    color: "#ffffff",           // White text
    borderRadius: "24px",
    padding: "100px 0px",
    boxShadow: "0 0 40px rgba(255, 255, 255, 0.05)", // soft glow
    border: "1px solid rgba(255, 255, 255, 0.1)",

  },
  footer: {
    width: "90%",
    maxWidth: "1216px",
    margin: "0 auto",
    display: "flex",
    flexDirection: "column",
    gap: "20px",
  },
  contactWrapper: {
    display: "flex",
    justifyContent: "space-between",
    flexWrap: "wrap",
    gap: "40px",
  },
  contactLeft: {
    flex: 1,
    minWidth: "250px",
    display: "flex",
    flexDirection: "column",
    gap: "14px",
    fontFamily:"Roboto"

  },
  contactRight: {
    flex: 1,
    minWidth: "250px",
    display: "flex",
    flexDirection: "column",
    gap: "16px",
    fontFamily:"Roboto"

  },
  contactRightItem: {
    display: "flex",
    alignItems: "center",
    gap: "12px",
    fontWeight: "500",
    color: "#ffffff",
    fontFamily:"Roboto"

  },
  heading: {
    fontSize: "32px",
    fontWeight: "600",
    fontFamily: "Poppins",  

  },
  subText: {
    fontSize: "16px",
    color: "#ffffffaa",
    fontFamily:"Roboto"

  },
  policyLinks: {
    display: "flex",
    flexWrap: "wrap",
    gap: "12px 28px",
    paddingTop: "20px",
    borderTop: "1px solid rgba(255, 255, 255, 0.1)",
    fontFamily: "Roboto",
    fontSize: "15px",
    "& a": {
      color: "#ffffffcc",
      textDecoration: "none",
    },
    "& a:hover": {
      color: "#FC8019",
    },
  },
  copyRights: {
    textAlign: "right",
    color: "#ffffff80",
    fontSize: "15px",
    fontWeight: "400",
    fontFamily:"Roboto"

  },
});

const RootFooter = () => {
  const classes = customStyles();

  return (
    <div className={classes.root}>
      <div className={classes.footer}>
        <div className={classes.contactWrapper}>
          <div className={classes.contactLeft}>
            <span className={classes.heading}>Contact Information</span>
            <span className={classes.subText}>
              Call us anytime – +91 73974 60454
            </span>
          </div>
          <div className={classes.contactRight}>
            <div className={classes.contactRightItem}>
              <EmailOutlinedIcon style={{ color: "#ffffff" }} />
              contact@pickaago.com
            </div>
            <div className={classes.contactRightItem}>
              <PhoneIcon style={{ color: "#ffffff" }} />
              +91 73974 60454
            </div>
            <div className={classes.contactRightItem}>
              <LocationOnIcon style={{ color: "#ffffff" }} />
              No 1104, 1st Main Rd, Stage I, Kengeri Satellite Town, Bengaluru,
              Karnataka 560060
            </div>
          </div>
        </div>
        <nav className={classes.policyLinks}>
          {policyLinks.map(({ label, path }) => (
            <Link key={path} to={path}>
              {label}
            </Link>
          ))}
        </nav>
        <div className={classes.copyRights}>
          © 2024 PickaaGo. All Rights Reserved.
        </div>
      </div>
    </div>
  );
};

export default RootFooter;
